export default {
  install(app) {
    // 复制
    // <div v-copy="number">copy</div>
    // <div v-copy="{ value: '111', onSuccess: () => {}, onError: () => {} }">copy</div>
    app.directive('copy', {
      mounted: (targetDom, binding) => {
        let onSuccess = () => {}
        let onError = () => {}
        if (binding.value && typeof binding.value === 'object') {
          targetDom.dataset.copyValue = binding.value.value

          onSuccess = binding.value.onSuccess

          onError = binding.value.onError
        } else {
          targetDom.dataset.copyValue = binding.value
        }
        targetDom.addEventListener('click', async () => {
          try {
            // 使用最新clipboard API
            await navigator.clipboard.writeText(targetDom.dataset.copyValue)
            onSuccess()
          } catch (err) {
            console.log(err)
            let $input = document.createElement('textarea')
            $input.style.opacity = '0'
            $input.value = targetDom.dataset.copyValue
            document.body.appendChild($input)
            $input.select()

            const isSuccess = document.execCommand('copy')
            isSuccess ? onSuccess() : onError()
            document.body.removeChild($input)
            $input = null
          }
        })
      },

      // 更新存储的值，存储在 dom 的 dataset 中
      updated: (el, binding) => {
        el.dataset.copyValue = binding.value.value
      },
    })
  },
}
